const krajPochodzenia = { t: 'Kraj pochodzenia', name: 'kraj-pochodzenia', hint: { url: '/country', cache: 'country-of-origin', select: true }}
export default krajPochodzenia